import { EffectCallback, useEffect, useRef } from 'react';

export const useEffectOnceOnCondition = (
  callback: EffectCallback,
  conditionFn: () => boolean,
  deps: any[] = []
) => {
  const hasRunEffectRef = useRef(false);

  useEffect(
    () => {
      if (hasRunEffectRef.current) {
        return;
      }

      if (conditionFn()) {
        hasRunEffectRef.current = true;
        return callback();
      }
    },
    deps.concat(callback, conditionFn)
  );
};
